/* eslint-disable indent */
const { getFrontSnippetPlaceholder, isPublicKeyYellowBrand } = require('./utils');
const { CountryOfOperationItems, countryShouldAcceptInteger } = require('../utils/constants');

const componentCodeFront = (formData, i18n) => {
  const unitPriceShouldAcceptInteger = countryShouldAcceptInteger(formData.publicKey);
  const isYellowBrand = isPublicKeyYellowBrand(formData.publicKey, formData.brand?.brand);

  const blueCode = [
    {
      code: `
  <html>
    <head>
      <script src="https://sdk.mercadopago.com/js/v2"></script>
    </head>
    <body>
      <div id="walletBrick_container"></div>
      <script>
        const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
          locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}'
        });
        const bricksBuilder = mp.bricks();

        const renderWalletBrick = async (bricksBuilder) => {
          const settings = {
            initialization: {
              redirectMode: '${formData.redirectMode || 'self'}',
            },

            customization: {
              texts: {
                action: '${formData.action || 'pay'}',
                valueProp: '${formData.valueProp || 'security_safety'}',
                theme: '${formData.theme || 'default'}',
              },
              visual: {
                hideValueProp: ${!formData?.showValueProp || false},
                buttonBackground: '${formData?.buttonBackground || 'default'}', // default, black, blue, white
                valuePropColor: '${formData?.valuePropColorBlueBrand || 'grey'}', // grey, white
                buttonHeight: '${formData?.buttonHeight || '48'}px', // min 48px - max free
                borderRadius: '${formData?.borderRadius || '6'}px',
                verticalPadding: '${formData?.verticalPaddingBlueBrand || '16'}px', // min 16px - max free
                horizontalPadding: '${formData?.horizontalPadding || '0'}px', // min 0px - max free
              },
              checkout: {
                theme: {
                  elementsColor: '#${formData?.elementsColor || '4287F5'}', // color hex code
                  headerColor: '#${formData?.headerColor || '4287F5'}', // color hex code
                },
              },
            },
            callbacks: {
              onReady: () => {
              /*
              Callback called when Brick is ready.
              Here you can hide loadings from your site, for example.
              */
              },
              onSubmit: (formData) => {
                /*
                Callback called when clicking Wallet Brick
                this is possible because the brick is a button
                at this time of submit, you must create the preference
                */
                const yourRequestBodyHere = {
                  items: [
                    {
                      id: 'YOUR_PRODUCT_ID',
                      title: 'YOUR_PRODUCT_TITLE',
                      description: 'YOUR_PRODUCT_DESCRIPTION',
                      quantity: YOUR_PRODUCT_QUANTITY,
                      unit_price: YOUR_PRODUCT_UNIT_PRICE, // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}.
                    },
                  ],
                  purpose: 'wallet_purchase',
                };
                return new Promise((resolve, reject) => {
                  fetch('/create_preference', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                      body: JSON.stringify(formData),
                    })
                      .then((response) => response.json())
                      .then((response) => {
                      // resolve the promise with the ID of the preference
                      resolve(response.preference_id);
                    })
                    .catch((error) => {
                      // handle error response when trying to create preference
                      reject();
                    });
                });
              },
            },
          };
          window.walletBrickController = await bricksBuilder.create(
            'wallet',
            'walletBrick_container',
            settings,
          );
        };
        renderWalletBrick(bricksBuilder);
      </script>
    </body>
  </html>
  `.replace(/^\s*[\r\n]/gm, ''),
      type: 'html',
      name: 'html',
    },
  ];

  const yellowCode = [
    {
      code: `
  <html>
    <head>
      <script src="https://sdk.mercadopago.com/js/v2"></script>
    </head>
    <body>
      <div id="walletBrick_container"></div>
      <script>
        const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
          locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}'
        });
        const bricksBuilder = mp.bricks();

        const renderWalletBrick = async (bricksBuilder) => {
          const settings = {
            initialization: {
              redirectMode: '${formData.redirectMode || 'self'}',
            },

            customization: {
              theme: '${formData.theme || 'default'}',
              valueProp: '${formData.valueProp || 'security_safety'}',
              customStyle: {
                hideValueProp: ${!formData?.showValueProp || false},
                valuePropColor: '${formData?.valuePropColorYellowBrand || 'blue'}', // blue, white, black
                buttonHeight: '${formData?.buttonHeight || '48'}px', // min 48px - max free
                borderRadius: '${formData?.borderRadius || '6'}px',
                verticalPadding: '${formData?.verticalPaddingYellowBrand || '8'}px', // min 8px - max free
                horizontalPadding: '${formData?.horizontalPadding || '0'}px', // min 0px - max free
              },
              checkout: {
                theme: {
                  elementsColor: '#${formData?.elementsColor || '4287F5'}', // color hex code
                  headerColor: '#${formData?.headerColor || '4287F5'}', // color hex code
                },
              },
            },
            callbacks: {
              onReady: () => {
              /*
              Callback called when Brick is ready.
              Here you can hide loadings from your site, for example.
              */
              },
              onSubmit: (formData) => {
                /*
                Callback called when clicking Wallet Brick
                this is possible because the brick is a button
                at this time of submit, you must create the preference
                */
                const yourRequestBodyHere = {
                  items: [
                    {
                      id: 'YOUR_PRODUCT_ID',
                      title: 'YOUR_PRODUCT_TITLE',
                      description: 'YOUR_PRODUCT_DESCRIPTION',
                      quantity: YOUR_PRODUCT_QUANTITY,
                      unit_price: YOUR_PRODUCT_UNIT_PRICE, // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}.
                    },
                  ],
                  purpose: 'wallet_purchase',
                };
                return new Promise((resolve, reject) => {
                  fetch('/create_preference', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                      body: JSON.stringify(formData),
                    })
                      .then((response) => response.json())
                      .then((response) => {
                      // resolve the promise with the ID of the preference
                      resolve(response.preference_id);
                    })
                    .catch((error) => {
                      // handle error response when trying to create preference
                      reject();
                    });
                });
              },
            },
          };
          window.walletBrickController = await bricksBuilder.create(
            'wallet',
            'walletBrick_container',
            settings,
          );
        };
        renderWalletBrick(bricksBuilder);
      </script>
    </body>
  </html>
  `.replace(/^\s*[\r\n]/gm, ''),
      type: 'html',
      name: 'html',
    },
  ];

  try {
    return isYellowBrand ? yellowCode : blueCode;
  } catch (e) {
    return [{
    code: getFrontSnippetPlaceholder(formData, i18n).replace(/^\s*[\r\n]/gm, ''),
    type: 'html',
    name: 'html' }];
  }
};

module.exports = componentCodeFront;
